import { MouseIcon } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { ButtonEditorRenderer } from "./editor";
import { ButtonEmailRenderer } from "./email";
import type { ButtonBlock, ButtonBlockProps } from "./types";
import { ButtonEmailPanelRenderer } from "./email-panel";
import ButtonWeb from "./web";
import { ButtonWebEditor } from "./web-editor";


export default registerBlock<ButtonBlockProps>({
  type: "button",
  name: "editorBlocksLibrary.blocks.button.title",
  description: "editorBlocksLibrary.blocks.button.description",
  Icon: MouseIcon,
  category: BlockCategory.ESSENTIALS,
  isTranslated: (locale, block) => {
    const content = (block as ButtonBlock).content;

    return (
      !!content?.[locale]?.text?.length && !!content?.[locale]?.href?.length
    );
  },
  components: {
    email: {
      component: ButtonEmailRenderer,
      editor: {
        component: ButtonEditorRenderer,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: ButtonEmailPanelRenderer,
      },
      compatibility: {
        rowBlock: true,
      },
    },
    web: {
      component: ButtonWeb,
      editor: {
        component: ButtonWebEditor,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: ButtonEmailPanelRenderer,
      },
      compatibility: {
        rowBlock: true,
      },
    },
  },
});

export { type ButtonVariant } from "./shared-button-styling";
